import {isMobileDevice} from '../utils/Utils';

export function addLiveChannelWatermark(videoPlayer: any, position: string) {
  // Remove existing watermark if any
  const existingWatermark = document.querySelector(
    '.liveChannelWatermarkContainer'
  );
  if (existingWatermark) {
    existingWatermark.remove();
  }

  const watermarkContainer = document.createElement('div');
  watermarkContainer.setAttribute(
    'class',
    `liveChannelWatermarkContainer position-${position}`
  );

  const zee5Logo = document.createElement('img');
  zee5Logo.setAttribute('class', 'liveChannelWatermarkIcon');
  zee5Logo.src =
    'https://stcf-prod.zee5.com/prod/zee5Videojs/resources/images/new_ZEE5_Watermark_Logo.svg';

  Object.assign(zee5Logo.style, {
    width: isMobileDevice() ? '35px' : '55px', // Adjust width based on device
    height: 'auto'
  });

  Object.assign(watermarkContainer.style, {
    position: 'absolute',
    zIndex: '10',
    pointerEvents: 'none'
  });

  // Apply CSS based on the position provided
  const positions: {[key: string]: {[prop: string]: string}} = {
    top_left: {top: '20px', left: '20px'},
    top_right: {top: '20px', right: '20px'},
    bottom_left: {bottom: '50px', left: '20px'},
    bottom_right: {bottom: '50px', right: '20px'}
  };

  if (positions[position]) {
    Object.assign(watermarkContainer.style, positions[position]);
  }

  watermarkContainer.appendChild(zee5Logo);

  const videoEL = videoPlayer && videoPlayer.el();
  if (videoEL) {
    videoEL.appendChild(watermarkContainer);
  }
}
